import { OrgHierarchyState } from '../state';
import { OrgHierarchyAction, OrgHierarchyActions } from '../actions/orgHierarchy.action';

const initialState: OrgHierarchyState = {
  selectedOrg: null,
  activeNode: null,
  rootOrg: null,
  orgs: null,
  isLoading: false,
  loaded: false,
  saved: false,
  saving: false,
  error: null,
  creating: false,
  created: false,
};


const getOrgById = (org, id) => {
  if (org?._id === id) return org;
  if (org?.children) {
    let result;
    for(let i = 0; !result && i < org.children.length; i+=1) {
      result = getOrgById(org.children[i], id);
    }
    return result;
  }
  return null;
};

const addChildrenToOrg = (rootOrg, children, id) => {
  const org = getOrgById(rootOrg, id);
  if (org) {
    org.children = children;
  }
  return rootOrg;
};


const orgHierarchyReducer = (state: OrgHierarchyState = initialState, action: OrgHierarchyAction): OrgHierarchyState => {
  switch (action.type) {
    case OrgHierarchyActions.LoadOrg:
      return {
        ...state,
        rootOrg: null,
        isLoading: true,
        loaded: false,
        saving: false,
        saved: false,
        error: null
      };
    case OrgHierarchyActions.LoadOrgSuccess:
      return {
        ...state,
        rootOrg: action.payload,
        isLoading: false,
        loaded: true,
        error: null
      };
    case OrgHierarchyActions.LoadOrgFailed:
      return {
        ...state,
        isLoading: false,
        loaded: false,
        error: action.payload
      };
    case OrgHierarchyActions.LoadOrgSubscriptionStatus:
      return {
        ...state,
        isLoading: true,
        loaded: false,
        error: null
      };
    case OrgHierarchyActions.LoadOrgSubscriptionStatusSuccess:
      return {
        ...state,
        rootOrg: {
          ...state?.rootOrg,
          billing_subscription: action?.payload?.billing_subscription
        },
        isLoading: false,
        loaded: true,
        error: null
      };
    case OrgHierarchyActions.LoadOrgSubscriptionStatusFailed:
      return {
        ...state,
        isLoading: false,
        loaded: false,
        error: action.payload
      }
    case OrgHierarchyActions.LoadOrgChildren:
      return {
        ...state,
        isLoading: true,
        loaded: false,
        error: null
      };
    case OrgHierarchyActions.LoadOrgChildrenSuccess:
      return {
        ...state,
        rootOrg: addChildrenToOrg(state.rootOrg, action.payload.children, action.payload.id),
        isLoading: false,
        loaded: true,
        error: null
      };
    case OrgHierarchyActions.LoadOrgChildrenFailed:
      return {
        ...state,
        isLoading: false,
        loaded: false,
        error: action.payload
      };
    case OrgHierarchyActions.SelectActiveNode:
      return {
        ...state,
        activeNode: action.payload
      };
    case OrgHierarchyActions.SelectOrg:
      return {
        ...state,
        selectedOrg: action.payload,
      };
    case OrgHierarchyActions.EditOrganization:
      return {
        ...state,
        saving: true,
        saved: false,
        error: null,
      };
    case OrgHierarchyActions.EditOrganizationSucceeded:
      return {
        ...state,
        saving: false,
        saved: true,
        error: null,
      };
    case OrgHierarchyActions.EditOrganizationFailed:
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload,
      };
    case OrgHierarchyActions.LoadOrgList:
      return {
        ...state,
        orgs: null,
        isLoading: true,
        loaded: false,
        saving: false,
        saved: false,
        error: null
      };
    case OrgHierarchyActions.LoadOrgListSucceeded:
      return {
        ...state,
        orgs: action.payload,
        isLoading: false,
        loaded: true,
        error: null
      };
    case OrgHierarchyActions.LoadOrgListFailed:
      return {
        ...state,
        isLoading: false,
        loaded: false,
        error: action.payload
      };
    case OrgHierarchyActions.CreateNewOrg:
      return {
        ...state,
        creating: true,
        created: false,
      };
    case OrgHierarchyActions.CreateNewOrgSucceeded:
      return {
        ...state,
        creating: false,
        created: true,
      };
    case OrgHierarchyActions.CreateNewOrgFailed:
      return {
        ...state,
        creating: true,
        created: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default orgHierarchyReducer;
